import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Select from "react-select";

const options = [
  { value: "greetings", label: "Greetings" },
  { value: "skin-names", label: "Skin Names" },
  { value: "questions", label: "Questions" },
];

export function SelectRoute() {
  let history = useHistory();
  const [route, setRoute] = useState(options[0]);
  const handleOptionChange = option => {
    setRoute(option);
    history.push(`/${option.value}`);
  };
  return (
    <Select
      value={route}
      onChange={option => {
        handleOptionChange(option);
      }}
      options={options}
      isSearchable={false}
    />
  );
}
